import * as XLSX from 'xlsx'
import { saveAs } from 'file-saver'
import { IChatDealerUsageRow, IChatUserUsageRow } from './models'

const DASH = '—'

const utcDate = (iso: string): string => new Date(iso).toLocaleDateString('tr-TR', { timeZone: 'UTC' })

export const buildDealerUsageSheetRows = (
  rows: IChatDealerUsageRow[]
): Record<string, string | number>[] =>
  rows.map(row => ({
    'SAP Kodu': row.DealerSapCode,
    Bayi: row.DealerName ?? DASH,
    Tur: row.TurnCount,
    // Faz-45: Index çalışanlarının remote turları ("Deneme Kartı Hariç" açıkken 0).
    'Remote Tur': row.RemoteTurnCount ?? 0,
    'Tekil Kullanıcı': row.UserCount,
    'Teknik Başarı (%)': row.TechnicalSuccessRate,
    Hata: row.ErrorCount,
    'Ort. Süre (ms)': row.AverageDurationMs,
    'p95 Süre (ms)': row.P95DurationMs,
    'Buton Payı (%)': row.ButtonSharePercent,
    // k-anonimlik eşiğinin altındaki bayide sayı YAZILMAZ (ADR-017).
    'Olumlu Oy': row.PositiveVotes ?? DASH,
    'Olumsuz Oy': row.NegativeVotes ?? DASH,
    'İlk Kullanım': utcDate(row.FirstUsedUtc),
    'Son Kullanım': utcDate(row.LastUsedUtc),
  }))

/** Kullanıcı sayfasında oy sütunu BİLEREK yoktur; kişi bazında oy görünürlüğü kapsam dışıdır. */
export const buildUserUsageSheetRows = (
  rows: IChatUserUsageRow[]
): Record<string, string | number>[] =>
  rows.map(row => ({
    Kullanıcı: row.FullName ?? DASH,
    'Kullanıcı Adı': row.UserName ?? DASH,
    'SAP Kodu': row.DealerSapCode,
    Bayi: row.DealerName ?? DASH,
    Remote: row.IsRemote ? 'Evet' : 'Hayır',
    Tur: row.TurnCount,
    'Teknik Başarı (%)': row.TechnicalSuccessRate,
    'Ort. Süre (ms)': row.AverageDurationMs,
    'Son Kullanım': utcDate(row.LastUsedUtc),
  }))

export const exportUsageToExcel = (
  sheetRows: Record<string, string | number>[],
  fileName: string,
  sheetName = 'Kullanım'
): void => {
  const sheet = XLSX.utils.json_to_sheet(sheetRows)
  const book = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(book, sheet, sheetName)
  const buffer = XLSX.write(book, { bookType: 'xlsx', type: 'array' })
  saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName)
}
